import React, { Component } from 'react';

class StictyWatcher extends Component {
	constructor(props) {
		super(props);

		this.scrollHandler = this.scrollHandler.bind(this);

		this.state = {
			extraClass: ''
		};
	}

	scrollHandler(event) {
		let minScreenWidth = this.props.minScreenWidth || 0;

		if (minScreenWidth > 0) {
			let windowWidth  = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

			if (minScreenWidth > windowWidth) {
				return;
			}
		}

		if (this.props.manual && this.props.top) {
			if (window.scrollY > this.props.top) {
				this.setState({
					extraClass: this.props.stickyClassName || ''
				});

				if (this.props.onStick) {
					this.props.onStick();
				}
			}
			else {
				this.setState({
					extraClass: ''
				});

				if (this.props.onUnStick) {
					this.props.onUnStick();
				}
			}
		}
		else {
			let elementTop = this.refs.el.getBoundingClientRect().top;
			let elementStyleTop = parseInt(getComputedStyle(this.refs.el).top.replace('px', ''));

			if (elementTop-elementStyleTop == 0) {
				this.setState({
					extraClass: this.props.stickyClassName || ''
				});

				if (this.props.onStick) {
					this.props.onStick();
				}
			}
			else {
				this.setState({
					extraClass: ''
				});

				if (this.props.onUnstick) {
					this.props.onUnstick();
				}
			}
		}
	}

	componentDidMount() {
		this.scrollContainer = (this.props.useBodyTag ? document.body : window);
		this.scrollContainer.addEventListener('scroll', this.scrollHandler);

		this.scrollHandler();
	}

	componentWillUnmount() {
		this.scrollContainer.removeEventListener('scroll', this.scrollHandler);
	}

	render() {
		let TagName = this.props.tagName || 'div';
		return (
			<TagName ref="el" className={this.props.className+' '+this.state.extraClass}>
				{this.props.children}
			</TagName>
		);
	}
}

export default StictyWatcher;



// WEBPACK FOOTER //
// ./src/components/StickyWatcher.js